"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapperError = exports.StyledSelect = exports.StyledRequired = exports.StyledPopOver = exports.StyledPlaceholder = exports.StyledMenuItemPlaceholder = exports.StyledMenuItem = exports.StyledInputLabel = exports.StyledInfoMessage = exports.StyledInfoIcon = exports.StyledIconButton = exports.StyledFormHelperText = exports.ParentWrapper = exports.MenuPropsSx = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _material = require("@mui/material");

var _InfoOutlined = _interopRequireDefault(require("@mui/icons-material/InfoOutlined"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

/* istanbul ignore next */
var StyledSelect = (0, _styledComponents.default)(_material.Select)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  // min-width: 200px;\n  height: 50px;\n  color: ", ";\n  font-size: 16px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.33;\n  letter-spacing: normal;\n  border-color: ", ";\n  padding: 0;\n  border-radius: 4px;\n\n  &:focus {\n    background: none;\n  }\n  &:hover {\n    border: 0;\n  }\n  &:before: {\n    border-bottom: 0\n  }\n  .MuiSelect-icon {\n    color: ", ";\n  }\n  .Mui-disabled {\n    cursor: not-allowed;\n  }\n  &.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border: 1px solid ", ";\n\n  }\n  .MuiSelect-select:focus {\n    background-color: transparent;\n  }\n"])), function (_ref) {
  var error = _ref.error,
      theme = _ref.theme;
  return error ? theme.palette.error.main : theme.palette.secondary.main;
}, function (_ref2) {
  var error = _ref2.error,
      theme = _ref2.theme;
  return "".concat(error ? theme.palette.error.main : theme.palette.color.darkIndigo);
}, function (_ref3) {
  var error = _ref3.error,
      theme = _ref3.theme;
  return error ? theme.palette.error.main : theme.palette.color.lightGrey;
}, function (_ref4) {
  var error = _ref4.error,
      theme = _ref4.theme;
  return "".concat(error ? theme.palette.error.main : theme.palette.secondary.main);
});
/* istanbul ignore next */

exports.StyledSelect = StyledSelect;
var StyledInputLabel = (0, _styledComponents.default)(_material.InputLabel)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 22px;\n  font-weight: 700;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  position: relative;\n  left: -12px;\n  margin-bottom: -8px;\n  pointer-events: unset;\n  text-transform: uppercase;\n\n  &.Mui-focused {\n    color: ", ";\n  }\n\n  .MuiInputLabel-asterisk {\n    color: ", ";\n    font-size: 18px;\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.secondary.main;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.secondary.main;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.primary.main;
});
exports.StyledInputLabel = StyledInputLabel;
var StyledRequired = (0, _styledComponents.default)('span')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 18px;\n  position: relative;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.primary.main;
});
exports.StyledRequired = StyledRequired;
var StyledIconButton = (0, _styledComponents.default)(_material.IconButton)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0 3px;\n  font-size: 1.2rem;\n"])));
exports.StyledIconButton = StyledIconButton;
var StyledInfoIcon = (0, _styledComponents.default)(_InfoOutlined.default)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 5px;\n  font-size: 20px;\n  color: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.secondary.main;
});
exports.StyledInfoIcon = StyledInfoIcon;
var StyledPopOver = (0, _styledComponents.default)(_material.Popover)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  pointer-events: none;\n"])));
/* istanbul ignore next */

exports.StyledPopOver = StyledPopOver;
var StyledInfoMessage = (0, _styledComponents.default)(_material.Typography)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  background-color: ", ";\n  padding: 5px;\n  font-size: 12px;\n  line-height: 14px;\n  padding: 8px;\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.secondary.main;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.color.blueLight;
});
/* istanbul ignore next */

exports.StyledInfoMessage = StyledInfoMessage;
var StyledWrapperError = (0, _styledComponents.default)('div')(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0;\n  margin-top: 9px;\n  p {\n    color: ", ";\n    font-size: 14px;\n    font-style: italic;\n  }\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.error.main;
});
/* istanbul ignore next */

exports.StyledWrapperError = StyledWrapperError;
var StyledMenuItem = (0, _styledComponents.default)(_material.MenuItem)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  border-bottom: 1px solid ", ";\n\n  &:last-child {\n    border-bottom: 0;\n  }\n  &:first-child {\n    border-top: 1px solid ", ";\n    background-color: ", ";\n    border-radius: 0;\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n    &.Mui-selected {\n      background-color: ", ";\n    }\n  }\n  &:first-child:hover {\n    background-color: rgba(0,0,0,0.04);\n  }\n\n  &.Mui-disabled {\n    background-color: transparent;\n  }\n  &.Mui-selected {\n    color: ", ";\n    background-color: ", " !important;\n    &:hover {\n      background-color: ", " !important;\n    }\n  }\n}\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.secondary.main;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.palette.color.veryLightGrey;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.palette.color.veryLightGrey;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.palette.color.white;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.palette.color.veryLightGrey;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.palette.secondary.main;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.palette.color.veryLightGrey;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.palette.color.veryLightGrey;
});
exports.StyledMenuItem = StyledMenuItem;
var StyledMenuItemPlaceholder = (0, _styledComponents.default)(_material.MenuItem)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n\n  &.Mui-disabled {\n    background-color: transparent;\n    opacity: 0.9;\n    pointer-events: unset;\n    &:hover {\n      background-color: transparent;\n    }\n}\n"])), function (_ref21) {
  var theme = _ref21.theme;
  return theme.palette.color.veryLightGrey;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.palette.color.veryLightGrey;
});
/* istanbul ignore next */

exports.StyledMenuItemPlaceholder = StyledMenuItemPlaceholder;
var StyledPlaceholder = (0, _styledComponents.default)('span')(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 16px;\n  color: ", ";\n"])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.palette.color.lightGrey;
});
/* istanbul ignore next */

exports.StyledPlaceholder = StyledPlaceholder;
var StyledFormHelperText = (0, _styledComponents.default)(_material.FormHelperText)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 14px;\n  margin-left: 0;\n"])), function (_ref24) {
  var theme = _ref24.theme;
  return theme.palette.color.grey;
});
exports.StyledFormHelperText = StyledFormHelperText;
var MenuPropsSx = {
  borderRadius: '0',
  '& .MuiPaper-root': {
    minWidth: '200px',
    boxShadow: 'unset',
    borderColor: 'color.veryLightGrey',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderTop: '0',
    borderRadius: '0',
    borderBottomRightRadius: '5px',
    borderBottomLeftRadius: '5px'
  },
  '& .MuiList-root': {
    paddingTop: '0px',
    paddingBottom: '0px'
  }
};
exports.MenuPropsSx = MenuPropsSx;
var ParentWrapper = (0, _styledComponents.default)('div')(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n{\n  width: 400px;\n}\n"])));
exports.ParentWrapper = ParentWrapper;